import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PersonalQualificationByAdvisorsV2 } from '../../dashboard-interfaces/personal-qualification-by-advisors-v2.interface';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ClubQualificationByAdvisorsV2 } from '../../dashboard-interfaces/club-qualification-by-advisors-v2.interface';
import { DashboardPiasConventionServiceV2 } from '../../dashboard-services/dashboard-pias-convention/dashboard-pias-convention-v2.service';
import { HttpStatusCode } from 'axios';
import { Router } from '@angular/router';
import { TabStateV2 } from '../../dashboard-interfaces/tab-state-v2.interface';
import { QualificationStatusesV2 } from '../../dashboard-enums/qualification-statuses-v2.enum';

@Component({
  selector: 'dashboard-pias-convention-v2',
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  templateUrl: './pias-convention-v2.component.html',
  styleUrl: './pias-convention-v2.component.scss'
})
export class PiasConventionComponentV2 implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private dashboardPiasConventionService = inject(DashboardPiasConventionServiceV2);

  protected readonly QualificationStatus = QualificationStatusesV2;

  protected currentUserRole: string = '';
  protected totalPersonalQualifiedAdvisorsCount: number = 0;

  setSprinner = signal(false);
  isQualifiedAdvisorsCountHidden = signal(false);
  isQualificationTableFilterAndPaginatorHidden = signal(false);

  private personalQualificationByAdvisorData: PersonalQualificationByAdvisorsV2[] = [];
  protected personalQualificationByAdvisorTableDisplayColumn: string[] = [];
  protected personalQualificationByAdvisorTableDataSource = new MatTableDataSource<PersonalQualificationByAdvisorsV2>();
  private clubQualificationByAdvisorData: ClubQualificationByAdvisorsV2[] = [];
  protected clubQualificationByAdvisorTableDisplayColumn: string[] = [];
  protected clubQualificationByAdvisorTableDataSource = new MatTableDataSource<ClubQualificationByAdvisorsV2>();

  personalQualificationByAdvisorTableFilterFc = new FormControl("");
  clubQualificationByAdvisorTableFilterFc = new FormControl("");

  @ViewChild('personalQualificationByAdvisorPaginator')
  personalQualificationByAdvisorPaginator!: MatPaginator;
  @ViewChild('personalQualificationByAdvisorSort')
  personalQualificationByAdvisorSort = new MatSort();
  @ViewChild('clubQualificationByAdvisorPaginator')
  clubQualificationByAdvisorPaginator!: MatPaginator;
  @ViewChild('clubQualificationByAdvisorSort')
  clubQualificationByAdvisorSort = new MatSort();

  @Input('tabState')
  set tabState(state: TabStateV2) {
    this.isCurrentTabActive = state.isActive;
    this.targetYear = state.targetYear;

    this.setAsCurrentTab();
  }

  protected conventionPersonalQualificationDisclaimer: string = "";
  protected conventionClubQualificationDisclaimer: string = "";

  protected isCurrentTabActive: boolean = false;
  protected targetYear: string = "";

  private readonly pqQualifiedStatus: string[] = [QualificationStatusesV2.MET_VIP_2, QualificationStatusesV2.MET_VIP_1, QualificationStatusesV2.MET_MAIN];

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.personalQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "branch", "lifeInsurance", "investment", "generalInsurance", "feeAndReferral", "total", "target", "shortfall", "metOrNotmet"];
      this.clubQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "branch", "grow", "ifast", "totalNetInflowNew", "target", "shortfall", "metOrNotmet"];
    }
    else {
      this.personalQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "lifeInsurance", "investment", "generalInsurance", "feeAndReferral", "total", "target", "shortfall", "metOrNotmet"];
      this.clubQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "grow", "ifast", "totalNetInflowNew", "target", "shortfall", "metOrNotmet"];
    }
  }

  ngAfterViewInit(): void {
    this.personalQualificationByAdvisorTableDataSource.paginator = this.personalQualificationByAdvisorPaginator;
    this.personalQualificationByAdvisorTableDataSource.sort = this.personalQualificationByAdvisorSort;

    this.clubQualificationByAdvisorTableDataSource.paginator = this.clubQualificationByAdvisorPaginator;
    this.clubQualificationByAdvisorTableDataSource.sort = this.clubQualificationByAdvisorSort;
  }

  async setAsCurrentTab(): Promise<void> {
    this.personalQualificationByAdvisorData = [];
    this.clubQualificationByAdvisorData = [];

    if (this.isCurrentTabActive) {
      await this.getPiasConventionData();

      // this.personalQualificationByAdvisorTableDataSource.data = this.personalQualificationByAdvisorData;
      this.__applyPersonalQualificationByAdvisorDataFilter();
      // this.clubQualificationByAdvisorTableDataSource.data = this.clubQualificationByAdvisorData;
      this.__applyClubQualificationByAdvisorDataFilter();

      if (['Advisor'].includes(this.currentUserRole)) {
        this.isQualifiedAdvisorsCountHidden.set(true);
        this.isQualificationTableFilterAndPaginatorHidden.set(true);
      }
    }
  }

  async getPiasConventionData() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardPiasConventionService
      .getDashboardPiasConvention(Number.parseInt(this.targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        this.mapPiasConventionData(responseData.data.responsedata.corporateapedata, responseData.data.responsedata.projectconfiguration);
      }
      // else if (this.currentUserRole === 'BDM') {
      //   this.mapPiasConventionData(responseData.data.responsedata.bdmapedata, responseData.data.responsedata.projectconfiguration);
      // }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.mapPiasConventionData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }
      else {
        this.mapPiasConventionData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }

      this.setDisclaimers(responseData.data.responsedata.disclamirdata);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  private setDisclaimers(disclaimer: any[]) {
    if (this.targetYear == new Date().getFullYear().toString()) {
      this.conventionPersonalQualificationDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "convention_personal_qualification")[0].dmText.toString();
      this.conventionClubQualificationDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "convention_club_qualification")[0].dmText.toString();
    } else {
      this.conventionPersonalQualificationDisclaimer = "The Information is based on data as at 31/12/2025.";
      this.conventionClubQualificationDisclaimer = "The Information is based on data as at 31/12/2025.";
    }
  }

  protected mapPiasConventionData(pcDataList: any[], projConfig: any[]) {
    let pqMetVip2: PersonalQualificationByAdvisorsV2[] = [];
    let pqMetVip1: PersonalQualificationByAdvisorsV2[] = [];
    let pqMetMain: PersonalQualificationByAdvisorsV2[] = [];
    let pqMetInvt: PersonalQualificationByAdvisorsV2[] = [];
    let pqNotMet: PersonalQualificationByAdvisorsV2[] = [];
    let pqResigned: PersonalQualificationByAdvisorsV2[] = [];

    let cqMetVip1: ClubQualificationByAdvisorsV2[] = [];
    let cqMetMain: ClubQualificationByAdvisorsV2[] = [];
    let cqMetGr: ClubQualificationByAdvisorsV2[] = [];
    let cqMetNq: ClubQualificationByAdvisorsV2[] = [];
    let cqNotMet: ClubQualificationByAdvisorsV2[] = [];
    let cqResigned: ClubQualificationByAdvisorsV2[] = [];

    const conventionPersonalMain: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Personal_Main")[0].pjConfValue);
    const conventionPersonalVip1: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Personal_VIP_1")[0].pjConfValue);
    const conventionPersonalVip2: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Personal_VIP_2")[0].pjConfValue);

    const conventionClub: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Club")[0].pjConfValue);

    this.totalPersonalQualifiedAdvisorsCount = 0

    pcDataList.forEach((pcDataItem) => {
      let pqData: PersonalQualificationByAdvisorsV2 = {
        repCode: pcDataItem.piasRepCode.toString(),
        personName: pcDataItem.agentRealName.toString(),
        branch: pcDataItem.branch.toString(),
        lifeInsurance: pcDataItem.conventionPerQualLifeInsurance.toString(),
        investment: pcDataItem.conventionPerQualInvestment.toString(),
        generalInsurance: pcDataItem.conventionPerQualGi.toString(),
        feeAndReferral: pcDataItem.conventionPerQualFeeAndReferral.toString(),
        total: pcDataItem.conventionPerQualTot.toString(),
        target: conventionPersonalMain.toString(),
        shortfall: "0",
        userGroup: pcDataItem.userGroup.toString(),
        qualificationStatus: ""
      };

      if (pcDataItem.convPerQuaStatus !== undefined) {
        pqData.qualificationStatus = pcDataItem.convPerQuaStatus.toString();
      } else {
        pqData.qualificationStatus = QualificationStatusesV2.NOT_MET;
      }

      let pqShortfall: number = 0;

      if (pcDataItem.conventionPerQualTot < conventionPersonalMain) {
        pqShortfall = conventionPersonalMain - pcDataItem.conventionPerQualTot;
      } else {
        pqShortfall = 0;
      }

      if (this.pqQualifiedStatus.includes(pqData.qualificationStatus)) {
        this.totalPersonalQualifiedAdvisorsCount = this.totalPersonalQualifiedAdvisorsCount + 1;
      }

      pqData.shortfall = pqShortfall.toString();

      // this.personalQualificationByAdvisorData.push(pqData);
      if (pqData.qualificationStatus == this.QualificationStatus.MET_VIP_2) {
        pqMetVip2.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.MET_VIP_1) {
        pqMetVip1.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.MET_MAIN) {
        pqMetMain.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.MET_INVT) {
        pqMetInvt.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.NOT_MET) {
        pqNotMet.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.RESIGNED) {
        pqResigned.push(pqData);
      }

      let cqData: ClubQualificationByAdvisorsV2 = {
        repCode: pcDataItem.piasRepCode.toString(),
        personName: pcDataItem.agentRealName.toString(),
        branch: pcDataItem.branch.toString(),
        grow: pcDataItem.conventionInvestClubQualGrow.toString(),
        ifast: pcDataItem.conventionInvestClubQualIfast.toString(),
        totalNetInflowNew: pcDataItem.conventionInvestClubQualTotNetInflow.toString(),
        target: conventionClub.toString(),
        shortfall: "0",
        userGroup: pcDataItem.userGroup.toString(),
        qualificationStatus: ""
      };

      if (pcDataItem.convInvQuaStatus !== undefined) {
        cqData.qualificationStatus = pcDataItem.convInvQuaStatus.toString();
      } else {
        cqData.qualificationStatus = QualificationStatusesV2.NOT_MET;
      }

      let cqShortfall: number = 0;

      if (pcDataItem.conventionInvestClubQualTotNetInflow < conventionClub) {
        cqShortfall = conventionClub - pcDataItem.conventionInvestClubQualTotNetInflow;
      } else {
        cqShortfall = 0;
      }

      cqData.shortfall = cqShortfall.toString();

      // this.clubQualificationByAdvisorData.push(cqData);

      if (cqData.qualificationStatus == this.QualificationStatus.MET_VIP_1) {
        cqMetVip1.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.MET_MAIN) {
        cqMetMain.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.MET_GR) {
        cqMetGr.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.MET_NQ) {
        cqMetNq.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.NOT_MET) {
        cqNotMet.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.RESIGNED) {
        cqResigned.push(cqData);
      }

    });

    // Sorting and Merging the all Personal qualification into one.
    pqMetVip2
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqMetVip1
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqMetMain
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqMetInvt
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqNotMet
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqResigned
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    // Sorting and Merging the all Club qualification into one.
    cqMetVip1
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqMetMain
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqMetNq
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqMetGr
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqNotMet
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqResigned
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    // this.personalQualificationByAdvisorData = this.personalQualificationByAdvisorData.filter(advisor => advisor.userGroup !== 'Affinity');
    // this.clubQualificationByAdvisorData = this.clubQualificationByAdvisorData.filter(advisor => advisor.userGroup !== 'Affinity');

    // this.personalQualificationByAdvisorData.sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total));
    // this.clubQualificationByAdvisorData.sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew));
  }

  protected __applyPersonalQualificationByAdvisorDataFilter() {
    let filterValue: string = this.personalQualificationByAdvisorTableFilterFc.value?.toString() || '';

    let tempPersonalQualificationByAdvisorTableData: PersonalQualificationByAdvisorsV2[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempPersonalQualificationByAdvisorTableData = this.personalQualificationByAdvisorData.filter(pqData =>
          pqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || pqData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || pqData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );

      } else {
        tempPersonalQualificationByAdvisorTableData = this.personalQualificationByAdvisorData.filter(pqData =>
          pqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || pqData.personName.toLowerCase().includes(filterValue.toLowerCase()
          ));
      }
    } else {
      tempPersonalQualificationByAdvisorTableData = this.personalQualificationByAdvisorData;
    }

    this.personalQualificationByAdvisorTableDataSource.data = tempPersonalQualificationByAdvisorTableData;
  }

  protected __applyClubQualificationByAdvisorDataFilter() {
    let filterValue: string = this.clubQualificationByAdvisorTableFilterFc.value?.toString() || '';

    let tempClubQualificationByAdvisorTableData: ClubQualificationByAdvisorsV2[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempClubQualificationByAdvisorTableData = this.clubQualificationByAdvisorData.filter(cqData =>
          cqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || cqData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || cqData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempClubQualificationByAdvisorTableData = this.clubQualificationByAdvisorData.filter(cqData =>
          cqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || cqData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempClubQualificationByAdvisorTableData = this.clubQualificationByAdvisorData;
    }

    this.clubQualificationByAdvisorTableDataSource.data = tempClubQualificationByAdvisorTableData;
  }
  clearClubSearch() {
    this.clubQualificationByAdvisorTableFilterFc.setValue('');   // clear input
    this.__applyClubQualificationByAdvisorDataFilter();          // reapply filter
  }
  clearSearch() {
    this.personalQualificationByAdvisorTableFilterFc.setValue('');   // clear input
    this.__applyPersonalQualificationByAdvisorDataFilter();          // reapply filter
  }

}
